module.exports = __webpack_public_path__ + "img/zxjd.973804d9.png";